export enum EventsName {
    NEWLOGIN = 'login_user_new',
    OLDLOGIN = 'login_user_old',
    OPENYOUTUBE = 'open_video_link_youtube',
    OPENLINKDIN = 'open_company_linkdin',
    VIEWDEMO = 'view_demo',
    OPENWORKPRESSWEBSITE = 'open_website_workpress',
    INITIALPAGE = 'initial_introduction_page',
    PROCCESSPAGE = 'proccess_page',
    LANDING_PAGE = 'landing_page',
    PRICESSPAGE = 'prices_page'
}